import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { create } from "../../../../styles/icons.js";
import { DrawFreedrawModule } from "./freedraw-module";

export class DrawFreedrawModuleContainer extends DrawingModuleContainer {
	constructor(canvas, getColor) {
		super(canvas);

		this.moduleId = "freedraw";
		this.toolbarWidth = "50px";
		this.icon = create;
		this.label = "draw";
		this.widths = ["1", "2", "3", "5", "10", "12", "15", "20"];
		this.widths.map((w, i) =>
			this.submodules.push(new DrawFreedrawModule(canvas, getColor, w, i))
		);
	}
}

window.customElements.define(
	"inspx-draw-freedraw-container",
	DrawFreedrawModuleContainer
);
